<template>
  <Portlet class="main-portlet" :fullHeight="true" :headSeparator="true">
    <template slot="Title">
      <router-view name="subPageHeader"></router-view>
    </template>
    <template slot="Options">
      <router-view name="pageActions"></router-view>
    </template>
    <template slot="PortletNav">
        <router-view name="pageSubMenu"></router-view>
    </template>
    <template slot="Content">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </template>
  </Portlet>
</template>

<script>
import Portlet from "@/components/common/Portlet";
import { mapState, mapActions } from "vuex";
import store from '@/store/index'
export default {
  name: "MasterTrack",
  created() {
    this.loadTrack(this.$route.params);
  },
  watch: {
    "$route.params": function(to, from) {
      this.loadTrack(this.$route.params);
    }
  },
  components: {
    Portlet
  },
  computed: mapState({
    sectionStore: state => Object.assign({}, state)
  }),
  data() {
    return {};
  },
  methods: {
    ...mapActions('tracks', ["loadTrack"])
  }
};
</script>
